/*
 *		Copyright (c) 2011-2015 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

/**
 * The nodeConfirmSync service manages the confirm lightbox that is displayed after an user invited to a share
 */

'use strict';

angular.module('access.Nodes').factory('nodeConfirmSync', [
    '$location',
    '$modal',
    '$rootScope',
    'Session',
    'SYNC_STATUS',
    function ($location, $modal, $rootScope, Session, SYNC_STATUS) {
        var SHOW_SYNC_LIGHTBOX = 'show_sync_lightbox';

        return function (currentNode) {
            Session.account.$promise.then(function (account) {
                if (!account.canSync() || !$location.search()[SHOW_SYNC_LIGHTBOX]) return;

                return _openConfirmSyncModal(currentNode)
                    .then(function (form) {
                        /**
                         * In general there is shouldn't be a case
                         * when user tries to UNSYNC shared folder.
                         * So we'll skip this case for the future
                         */
                        if (form.synced === SYNC_STATUS.NOT_SYNCED) {
                            return;
                        }

                        var nodeUpdate = currentNode.uuid ? { uuid: currentNode.uuid } : { id: currentNode.id };

                        nodeUpdate.synced = form.synced;
                        nodeUpdate.syncName = form.syncName;

                        return currentNode.$sync.call(nodeUpdate);
                    })
                    .finally(function () {
                        $location.search(SHOW_SYNC_LIGHTBOX, null);
                    });
            });
        };

        function _openConfirmSyncModal(currentNode) {
            var $modalScope = $rootScope.$new();

            $modalScope.node = currentNode;
            $modalScope.isInitialFolderSync = true;
            $modalScope.hasDesktopClient = $rootScope.account.hasDesktopClient();
            $modalScope.lastSyncWithDesktop = $rootScope.account.lastSyncWithDesktop();

            return $modal.open({
                controller: 'NodeSyncController',
                windowClass: 'sync-dialog',
                backdrop: 'static',
                keyboard: false,
                scope: $modalScope
            }).result;
        }
    }
]);
